import { render, staticRenderFns } from "./Preference.vue?vue&type=template&id=8e4e15cc&scoped=true&"
import script from "./Preference.vue?vue&type=script&lang=js&"
export * from "./Preference.vue?vue&type=script&lang=js&"
import style0 from "./Preference.vue?vue&type=style&index=0&id=8e4e15cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e4e15cc",
  null
  
)

export default component.exports